// @ts-strict-ignore
import React from 'react'
import styled from 'styled-components/native'
import { useNavigation } from '@react-navigation/native'

import { getColourScheme } from 'APP/Helpers/AppearanceUtils'
import useScreenView from 'APP/Hooks/useScreenView'

import I18n from 'APP/I18n'
import UrlBuilder from 'APP/Helpers/UrlBuilder'
import Button from 'APP/Converse/Button'

const HelpButton = styled(Button)`
  height: 44px;
`

export const HelpButtonComponent = () => {
  const { isBigScreen } = useScreenView()
  const navigation = useNavigation()

  return (
    <HelpButton
      variant="tertiary"
      widthVariant="content"
      title={isBigScreen && I18n.t('MindScreen.help')}
      icon="warning-outline"
      iconVariant="ionicons"
      analyticsName="mind-emergency"
      onPress={() =>
        navigation.navigate('cmsScreen', {
          uri: UrlBuilder.cmsConsultUrl('emergencyCare', getColourScheme()),
          screen: 'cms',
          showShareButton: false,
        })
      }
      testID="TOOLBAR_RIGHT_BUTTON"
    />
  )
}
